import src from "IMAGE";
export default { src, width: 471, height: 525, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
